exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".stations-index {\n  padding: 2em 1em;\n  width: 100%; }\n\n.station-panel {\n  width: 100%;\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n  padding: 1em 0; }\n", ""]);

